export * from "@/ui/components/primitives/Pill/Pill";
export * from "@/ui/components/primitives/Pill/Pill.config";
